import React from "react";
import { CentralIconBase, type CentralIconBaseProps } from "../CentralIconBase";
import { Path } from "react-native-svg";

export const IconProjects: React.NamedExoticComponent<CentralIconBaseProps> = React.memo((props) => {
  return <CentralIconBase {...props} maskId="square-filled-radius-0-stroke-2-IconProjects"><Path d="M19.8027 21H4.19922L1.75391 10H22.248L19.8027 21Z" fill="currentColor"/><Path d="M20.001 8.5H4.00098V6.5H20.001V8.5Z" fill="currentColor"/><Path d="M18.001 5H6.00098V3H18.001V5Z" fill="currentColor"/></CentralIconBase>;
});

export default IconProjects;
